/* eslint-disable @typescript-eslint/no-extra-semi */
import React, { useState } from 'react'
import styled from 'styled-components'
import { Select, PrimaryButton } from '@cb/apricot-react'
import { useRecoilState } from 'recoil'
import { loginOrgState } from '@landscape/ui-lib'
import { isEmpty } from 'lodash'
import { loginUser, selectUser, User } from '@landscape/ui-redux'
import { useDispatch, useSelector } from 'react-redux'
import { getClient } from 'apollo/configuration'

const ClickableLink = styled.a`
  color: #2903ff;
`

const InfoSection = styled.div`
  text-align: left;
  margin-bottom: 40px;

  & a {
    color: #2903ff;
  }
`
interface SelectInstitutionProps {
  di_code: string
}

const SelectInstitution: React.FC<SelectInstitutionProps> = ({ di_code }) => {
  const dispatch = useDispatch()
  const [loginOrg, setLoginOrg] = useRecoilState(loginOrgState)
  const [value, setValue] = useState(loginOrg.selectionIdx)
  const user = useSelector(selectUser)

  const schoolList = loginOrg.roPairs.map((item, index) => {
    return {
      label: item.on,
      value: index,
    }
  })

  const handleSelectSchool = (event: any) => {
    if (!isEmpty(event)) {
      const selectedIndex = Number.parseInt(event, 10)
      // console.log('selected index value', loginOrg.roPairs[selectedIndex])
      setValue(selectedIndex)
    } else {
      setValue(null)
    }
  }

  const handleNext = async (event: any) => {
    setLoginOrg({
      ...loginOrg,
      selectionIdx: value,
    })

    getClient().orgId = loginOrg.roPairs[value].oid

    let payload: User = {
      ...user,
      user_role: loginOrg.roPairs[value].rn,
      schoolName: loginOrg.roPairs[value].on,
      rid: loginOrg.roPairs[value].rid,
      di_code,
    }
    if (import.meta.env.VITE_NODE_ENV !== 'production') {
      console.log('SelectInstitution', JSON.stringify({ ...payload }))
    }

    dispatch(loginUser(payload))
  }

  return (
    <div className="container" id="top-of-content">
      <div className="cb-padding-top-48 cb-padding-bottom-48" id="main-content">
        <InfoSection>
          <h4 className="cb-roboto-slab-bold cb-margin-bottom-8">Please select an institution</h4>
          <div className="container">
            <div className="row cb-padding-top-24">
              <p>
                You have Landscape access for multiple institutions. Please select the institution
                you'd like to work with.
                <br />
              </p>
              <p>
                <b>Note</b>:{' '}
                <i>
                  Once an institution has been selected, to log into a different institution, you
                  must first completely log out of the Landscape web application.
                </i>
              </p>
            </div>
            <div className="row cb-padding-top-24">
              <span>Questions? Email&nbsp;</span>
              <ClickableLink href="mailto:futureadmissions@collegeboard.org">
                futureadmissions@collegeboard.org
              </ClickableLink>
            </div>
            <div className="row cb-padding-top-24">
              <Select
                labelNoValue="Select Option"
                values={schoolList}
                onChange={handleSelectSchool}
              />
            </div>
            <div className="row cb-padding-top-24">
              <PrimaryButton onClick={handleNext}>Next</PrimaryButton>
            </div>
          </div>
        </InfoSection>
      </div>
    </div>
  )
}

export { SelectInstitution }
